export const GAM_DEVICE_CATEGORY = {
  30000: "Desktop",
  30001: "Smartphone",
  30002: "Tablet",
  30003: "Feature phone",
  30004: "Connected TV",
};
